import { getPageVisibilityState } from '../../hidden-timing';
function getPageVisibilityUpToTTAI(interaction) {
  var start = interaction.start,
    end = interaction.end;
  return getPageVisibilityState(start, end);
}
export default getPageVisibilityUpToTTAI;